import { Button, Col, Form, Row } from 'antd';
import { ContractInfo } from 'domain/entities/ContractEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DataView } from './components/DataView';

const CU06301Page = (props: AppProps) => {
    const { listedPropertyId } = useParams();
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const [data, setData] = React.useState<ContractInfo>();
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const navigate = useNavigate();

    const { propertyUseCase } = props;

    useEffect(() => {
        initiateDefaultData();
    }, []);

    const initiateDefaultData = async () => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getConfirmContract({
                listedPropertyId: Number(listedPropertyId),
            });
            const contractInfo = response.result;
            setData(contractInfo);
            form.setFieldsValue({
                isAgreed: contractInfo.isAgreed ? [1] : null,
            });
            onChangeForm();
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const submit = async () => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.confirmContract({
                agencyContractId: data?.agencyContractId,
            });
            if (response?.status == 200) {
                navigate(-1);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-015-02-container"
        >
            <PageTitle title="代理契約内容の確認" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <Form
                    onValuesChange={onChangeForm}
                    id="top-form"
                    form={form}
                    className="purchase-form-container w-full md:w-full"
                >
                    <div className="section-wrapper">
                        <DataView data={data} />
                    </div>
                    <div className="section-wrapper">
                        <Row justify="center" className="w-full mb-6">
                            <Col span={12} style={{ paddingLeft: '8px' }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    disabled={btnDisable}
                                    onClick={submit}
                                    className="button-container"
                                >
                                    送信する
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </section>
        </div>
    );
};

export default CU06301Page;
